/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Data_Storage_MapInputs */

const en_ui_data_storage_map = /** @type {(inputs: Ui_Data_Storage_MapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Heatmap`)
};

const de_ui_data_storage_map = /** @type {(inputs: Ui_Data_Storage_MapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Heatmap`)
};

/**
* | output |
* | --- |
* | "Heatmap" |
*
* @param {Ui_Data_Storage_MapInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_data_storage_map = /** @type {((inputs?: Ui_Data_Storage_MapInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Data_Storage_MapInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_data_storage_map(inputs)
	return de_ui_data_storage_map(inputs)
});